import { createSelector } from '@ngrx/store';
import { AppStatus } from './app.state';
import { Status } from '../models/Status';
import { AdaptiveQuestionnaireService } from '../home/adaptive-questionnaire.service';

export const selectForm = (state) => state.form;
export const selectIsInProgress = createSelector(
  selectForm,
  (state) => state.appStatus === AppStatus.INPROGRESS,
);
export const selectIsNotInProgress = createSelector(
  selectForm,
  (state) => state.appStatus !== AppStatus.INPROGRESS,
);
export const selectIsSubmittingWithNoErrors = createSelector(
  selectForm,
  (state) =>
    state.appStatus === AppStatus.SUBMITTING &&
    state.persistentError === undefined,
);
export const selectDisableSubmitButton = createSelector(
  selectForm,
  (state) =>
    state.appStatus !== AppStatus.INPROGRESS ||
    state.reqFieldCounter.answered !== state.reqFieldCounter.required ||
    state.saveStatus !== Status.SAVED ||
    (AdaptiveQuestionnaireService.isAdaptiveQuestionnaire(
      state.questionnaire,
    ) &&
      state.questionnaireResponse.status !== 'completed'),
);
export const selectShowSaveButton = createSelector(
  selectForm,
  (state) => !state.autoSave && state.saveStatus === Status.UNSAVED,
);
export const selectDisableSaveButton = createSelector(
  selectForm,
  (state) => state.hasValidationError,
);
export const selectShouldSave = createSelector(
  selectForm,
  (state) => state.autoSave || state.detail?.type === 'attachment',
);
export const selectSaveStatus = createSelector(
  selectForm,
  (state) => state.saveStatus,
);
export const selectQuestionnaire = createSelector(
  selectForm,
  (state) => state.questionnaire,
);
export const selectQr = createSelector(
  selectForm,
  (state) => state.questionnaireResponse,
);
export const selectCdexTask = createSelector(selectForm, (state) => state.task);
export const selectDetail = createSelector(selectForm, (state) => state.detail);
export const selectLandingStages = createSelector(
  selectForm,
  (state) => state.landing.stages,
);
export const selectSubmitStages = createSelector(
  selectForm,
  (state) => state.submit.stages,
);
export const selectPersistentError = createSelector(
  selectForm,
  (state) => state.persistentError,
);
export const selectReqFieldCounter = createSelector(
  selectForm,
  (state) => state.reqFieldCounter,
);
export const selectLogCount = createSelector(
  selectForm,
  (state) => state.logError.length,
);
export const selectLogError = createSelector(
  selectForm,
  (state) => state.logError,
);
